import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { getApi } from "../../services/api/globalApi";
import { useNavigate } from "react-router";
import { provinceListColumns } from "../../constant/tablesColumns/tablesColums";

export default function ProvinceList() {
  const [provinces, setProvinces] = useState([]);

  const getProvinces = async (params) => {
    const path = "admin/provinces";
    try {
      const response = await getApi({ path, params: { ...params } });
      setProvinces(response?.data?.result);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProvinces({});
  }, []);

  const data = provinces?.map((item) => {
    return {
      ...item,
      key: item._id,
      cityNumber: item?.cities?.length || "-",
      id: item._id,
    };
  });

  console.log(data);

  const navigate = useNavigate();

  const editUser = (data) => {
    navigate("/edit-cities", { state: data });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست استان ها"} />
      <Table columns={provinceListColumns} rows={data} onEdit={editUser} />
    </div>
  );
}
